import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { StickyCTA } from '../components/StickyCTA';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-425">
      <div data-id="element-426">
        <HeroSection data-id="element-427" />

        <Suspense fallback={null} data-id="element-428">
          <TrustBar data-id="element-429" />
          <ContrastSection data-id="element-430" />
          <ForWhomSection data-id="element-431" />
          <BenefitsSection data-id="element-432" />
          <ContentPreview data-id="element-433" />
          <BonusSection data-id="element-434" />
          <PricingSection data-id="element-435" />
        </Suspense>

        <Suspense fallback={null} data-id="element-436">
          <GuaranteeSection data-id="element-437" />
          <TestimonialsSection data-id="element-438" />
          <ExpertSection data-id="element-439" />
          <FAQSection data-id="element-440" />
          <Footer data-id="element-441" />
          <SocialProofPopup data-id="element-442" />
          <StickyCTA data-id="element-443" />
        </Suspense>
      </div>
    </main>;
}